const Images = {
    pro1: require("./IMG_3521.jpg"),
    pro2: require("./IMG_0428.jpg"),
    pro3: require("./IMG_5058.JPG"),
    bath: [
      require("./IMG_5069.JPG"),
      require("./IMG_5073.JPG"),
      require("./IMG_5070.JPG"),
      require("./IMG_5071.JPG"),
      require("./IMG_5072.JPG"),
      require("./IMG_5074.JPG"),
    ],
    kitchen: [
      require("./IMG_2574.jpg"),
      require("./IMG_2573.jpg"),
      require("./IMG_5055.JPG"),
      require("./IMG_5078.JPG"),
      require("./IMG_5079.JPG"),
      require("./IMG_5081.JPG"),
      require("./IMG_5076.JPG"),
      
    ],
    renovation: [
      require("./IMG_774.jpg"),
      require("./IMG_880.jpg"),
      require("./IMG_778.jpg"),  
      require("./IMG_882.jpg"),
      require("./IMG_775.jpg"),
      require("./IMG_777.jpg"),
      require("./IMG_773.jpg"),
      require("./IMG_772.jpg"),
      require("./IMG_2460.jpg"),
      require("./IMG_2520.jpg"),
      require("./IMG_5062.JPG"),
      require("./IMG_5064.JPG"),
      require("./IMG_5068.JPG"),
      require("./IMG_5082.JPG"),
      require("./IMG_5065.JPG"),
      require("./IMG_5066.JPG"),
      require("./IMG_776.jpg"),
      ],
  };
  
  export default Images;